"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModernaTheme = void 0;
const space = new Array(192)
    .fill(null)
    .map((_value, i) => i * 4);
exports.ModernaTheme = {
    borders: {
        tableBorder: "none",
        tableHeaderBorder: "0.5px solid #FFFFFF",
        tableBodyBorder: "0.5px solid #005E83",
        tableFooterBorder: "0.5px solid #FFFFFF"
    },
    breakpoints: ["720px", "1024px", "1440px", "1920px"],
    colorsDark: {
        accent01: "#ADDCF2",
        accent02: "#75C4E9",
        accent03: "#3CABE0",
        accent04: "#F2FAFD",
        background01: "#01283C",
        background02: "#024667",
        background03: "#02608C",
        backgroundNeutral01: "#09090B",
        backgroundNeutral02: "#22252A",
        backgroundNeutral03: "#343740",
        backgroundNeutral04: "#454A55",
        backgroundNeutral05: "#565C6A",
        backgroundOverlay01: "#09090BCC",
        buttonActiveBackgroundColorPrimary: "#3CABE0",
        buttonActiveBackgroundColorSecondary: "transparent",
        buttonActiveBorderColorPrimary: "#3CABE0",
        buttonActiveBorderColorSecondary: "#E31837",
        buttonActiveColorPrimary: "#FFFFFF",
        buttonActiveColorSecondary: "#FFFFFF",
        buttonBackgroundColorDisabled: "#B3B5B8",
        buttonBackgroundColorPrimary: "#E31837",
        buttonBackgroundColorSecondary: "transparent",
        buttonBorderColorPrimary: "#E31837",
        buttonBorderColorSecondary: "#FFFFFF",
        buttonColorPrimary: "#FFFFFF",
        buttonColorSecondary: "#FFFFFF",
        buttonColorTertiary: "#FFFFFF",
        buttonFocusBorderColorPrimary: "#02608C",
        buttonFocusBorderColorSecondary: "#E31837",
        buttonFocusBorderColorTertiary: "#FFFFFF",
        buttonHoverBackgroundColorPrimary: "#3CABE0",
        buttonHoverBackgroundColorSecondary: "transparent",
        buttonHoverBorderColorPrimary: "#3CABE0",
        buttonHoverBorderColorSecondary: "#E31837",
        buttonHoverColorPrimary: "#FFFFFF",
        buttonHoverColorSecondary: "#FFFFFF",
        cta01: "#E31837",
        cta01Text: "#FFFFFF",
        cta01TextHover: "#FFFFFF",
        cta02: "#FFFFFF",
        cta02Text: "#FFFFFF",
        cta02TextHover: "#FFFFFF",
        disabled01: "#B3B5B8",
        dropdownActive: "#79CCF4",
        dropdownHover: "#F2FAFD",
        error01: "#F8C5CD",
        error02: "#F29BAB",
        error03: "#E0708F",
        gradientTop: "linear-gradient(to bottom, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
        gradientBottom: "linear-gradient(to top, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
        headline01: "#FFFFFF",
        headline02: "#D8E9F1",
        headlineLevel1: "#FFFFFF",
        iconButtonActiveBackgroundColor: "#7BAFCF",
        iconButtonBackgroundColor: "#024667",
        iconButtonColorPrimary: "#FFFFFF",
        iconButtonColorSecondary: "#FFFFFF",
        iconButtonFocusBorderColor: "#02608C",
        iconButtonHoverBackgroundColor: "#02608C",
        iconButtonHoverBorderColor: "#E31837",
        iconButtonOutlineBackgroundColor: "transparent",
        iconButtonOutlineColor: "#E31837",
        inputBackgroundColor: "#FFFFFF",
        inputLabel: "#191F2A",
        link01: "#ADDCF2",
        link02: "#4A8DAF",
        notification01: "#ADDCF2",
        notification02: "#7BAFCF",
        notification03: "#57829F",
        stroke01: "#FFFFFF",
        stroke02: "#565C6A",
        stroke03: "#079AE0",
        success01: "#9DF1BE",
        success02: "#7FCC95",
        success03: "#5D996F",
        tableBodyEvenBackgroundColor: "#FFFFFF",
        tableBodyOddBackgroundColor: "#F9F9FA",
        tableHeaderBackgroundColor: "#005E83",
        tableFooterBackgroundColor: "#D8D8D8",
        text01: "#FFFFFF",
        text02: "#D8D8D8",
        text03: "#A6C9D8",
        text04: "#191F2A",
        warning01: "#FDE39D",
        warning02: "#F8C485",
        warning03: "#E8A061"
    },
    colorsLight: {
        accent01: "#079AE0",
        accent02: "#024667",
        accent03: "#0379B2",
        accent04: "#F2FAFD",
        background01: "#FFFFFF",
        background02: "#F2FAFD",
        background03: "#ADDCF2",
        backgroundNeutral01: "#F9F9FA",
        backgroundNeutral02: "#EAEBEF",
        backgroundNeutral03: "#DCDEE3",
        backgroundNeutral04: "#9499A8",
        backgroundNeutral05: "#697084",
        backgroundOverlay01: "#F9F9FACC",
        buttonActiveBackgroundColorPrimary: "#01283C",
        buttonActiveBackgroundColorSecondary: "transparent",
        buttonActiveBorderColorPrimary: "#01283C",
        buttonActiveBorderColorSecondary: "#0379B2",
        buttonActiveColorPrimary: "#FFFFFF",
        buttonActiveColorSecondary: "#01283C",
        buttonBackgroundColorDisabled: "#F0F0F1",
        buttonBackgroundColorPrimary: "#0379B2",
        buttonBackgroundColorSecondary: "transparent",
        buttonBorderColorPrimary: "#0379B2",
        buttonBorderColorSecondary: "#01283C",
        buttonColorPrimary: "#FFFFFF",
        buttonColorSecondary: "#01283C",
        buttonColorTertiary: "#01283C",
        buttonFocusBorderColorPrimary: "#01283C",
        buttonFocusBorderColorSecondary: "#0379B2",
        buttonFocusBorderColorTertiary: "#01283C",
        buttonHoverBackgroundColorPrimary: "#01283C",
        buttonHoverBackgroundColorSecondary: "transparent",
        buttonHoverBorderColorPrimary: "#01283C",
        buttonHoverBorderColorSecondary: "#0379B2",
        buttonHoverColorPrimary: "#FFFFFF",
        buttonHoverColorSecondary: "#01283C",
        cta01: "#0379B2",
        cta01Text: "#FFFFFF",
        cta01TextHover: "#FFFFFF",
        cta02: "#01283C",
        cta02Text: "#01283C",
        cta02TextHover: "#01283C",
        disabled01: "#F0F0F1",
        dropdownActive: "#79CCF4",
        dropdownHover: "#F2FAFD",
        error01: "#E22929",
        error02: "#F58A8A",
        error03: "#FFF3F3",
        gradientTop: "linear-gradient(to bottom, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
        gradientBottom: "linear-gradient(to top, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0.3) 90%, rgba(255, 255, 255, 0) 100%)",
        headline01: "#191F2A",
        headline02: "#383D47",
        headlineLevel1: "headline01",
        iconButtonActiveBackgroundColor: "#79CCF4",
        iconButtonBackgroundColor: "#F2FAFD",
        iconButtonColorPrimary: "#191F2A",
        iconButtonColorSecondary: "#191F2A",
        iconButtonFocusBorderColor: "#01283C",
        iconButtonHoverBackgroundColor: "#ADDCF2",
        iconButtonHoverBorderColor: "#0379B2",
        iconButtonOutlineBackgroundColor: "transparent",
        iconButtonOutlineColor: "#191F2A",
        inputBackgroundColor: "#FFFFFF",
        inputLabel: "#191F2A",
        link01: "#0379B2",
        link02: "#024667",
        notification01: "#079AE0",
        notification02: "#79CCF4",
        notification03: "#EBF8FE",
        stroke01: "#383D47",
        stroke02: "#D1D2D5",
        stroke03: "#079AE0",
        success01: "#039855",
        success02: "#75CBA4",
        success03: "#EBF8F2",
        tableBodyEvenBackgroundColor: "pink",
        tableBodyOddBackgroundColor: "#F9F9FA",
        tableHeaderBackgroundColor: "#005E83",
        tableFooterBackgroundColor: "#D8D8D8",
        text01: "#191F2A",
        text02: "#383D47",
        text03: "#083952",
        text04: "#FFFFFF",
        warning01: "#FDB022",
        warning02: "#FFD785",
        warning03: "#FFF9EC"
    },
    fonts: {
        body: "Aeonik",
        code: "RobotoMono",
        headlineLevel1: "Aeonik"
    },
    fontSizes: [12, 14, 16, 18, 20, 24, 30, 36, 48, 60, 72, 96, 128],
    fontWeights: {
        bold: 700,
        light: 300,
        medium: 500,
        regular: 400
    },
    grid: {
        gridDesktopColumnCount: 12,
        gridMobileColumnCount: 4,
        gridTabletColumnCount: 8
    },
    lineHeights: [
        16 / 12,
        20 / 14,
        1.5,
        28 / 18,
        1.4,
        32 / 24,
        36 / 30,
        40 / 36,
        1,
        1,
        1,
        1,
        1
    ],
    space,
    radii: {
        small: 4,
        medium: 8,
        large: 10,
        buttonBorderRadius: 8,
        iconButtonBorderRadiusCircle: 50,
        iconButtonBorderRadiusSquare: 8,
        tableBorderRadius: 12,
        inputBorderRadius: 8
    },
    shadows: {
        boxShadow01: "0px 8px 28px 0px rgba(0, 0, 0, 0.08), 0px 2px 24px 0px rgba(0, 0, 0, 0.02)",
        boxShadow02: "0px 16px 32px 0px rgba(0, 0, 0, 0.10), 0px 2px 12px 0px rgba(0, 0, 0, 0.08)",
        boxShadow03: "0px 8px 44px 0px rgba(0, 0, 0, 0.16), 0px 2px 24px 0px rgba(0, 0, 0, 0.04)",
        boxShadowInset01: "inset 0px 8px 28px 0px rgba(0, 0, 0, 0.08), inset 0px 2px 24px 0px rgba(0, 0, 0, 0.02)",
        boxShadowInset02: "inset 0px 16px 32px 0px rgba(0, 0, 0, 0.10), inset 0px 2px 12px 0px rgba(0, 0, 0, 0.08)",
        boxShadowInset03: "inset 0px 8px 44px 0px rgba(0, 0, 0, 0.16), inset 0px 2px 24px 0px rgba(0, 0, 0, 0.04)",
        textShadow01: "0px 0px 8px rgba(0, 0, 0, 0.40), 0px 0px 20px rgba(0, 0, 0, 0.40)"
    },
    transitions: {
        colorMedium: "background-color 100ms, border-color 100ms, color 100ms, opacity 100ms, box-shadow 100ms, text-decoration-color 100ms",
        colorSlow: "background-color 300ms, border-color 300ms, color 300ms, opacity 300ms, box-shadow 300ms, text-decoration-color 300ms",
        easeOutFast: "background-color 100ms, border-color 100ms, color 100ms, opacity 100ms, box-shadow 100ms, text-decoration-color 100ms, transform 300ms cubic-bezier(0.4, 0, 0, 1)",
        easeOutMedium: "background-color 200ms, border-color 200ms, color 200ms, opacity 200ms, box-shadow 200ms, text-decoration-color 200ms, transform 400ms cubic-bezier(0.4, 0, 0.06, 1)",
        easeOutSlow: "background-color 400ms, border-color 400ms, color 400ms, opacity 400ms, box-shadow 400ms, text-decoration-color 400ms, transform 800ms cubic-bezier(0.4, 0, 0.06, 1)"
    },
    zIndices: {
        dropdown: 1200,
        modal: 1300,
        navbar: 1100,
        panel: 1150
    },
    sizes: {
        containerDesktopMargin: 64,
        containerDesktopMaxHeight: 1440,
        containerDesktopMaxWidth: 1440,
        containerMobileMargin: 16,
        containerMobileMaxHeight: 748,
        containerMobileMaxWidth: 748,
        containerTabletMargin: 40,
        containerTabletMaxHeight: 748,
        containerTabletMaxWidth: 748,
        gridDesktopColumnGutter: 32,
        gridMobileColumnGutter: 16,
        gridTabletColumnGutter: 24,
        iconXxs: 12,
        iconXs: 16,
        iconSm: 20,
        iconMd: 24,
        iconLg: 36,
        iconXl: 48
    }
};
//# sourceMappingURL=ModernaTheme.js.map